module.exports = __webpack_public_path__ + "static/media/employee-dir.979769a4.png";